var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMeditation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 177.165,
    height: 221.026,
    viewBox: "0 0 177.165 221.026",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22459",
    "data-name": "Group 22459",
    transform: "translate(22709.811 22360.584)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11889",
    "data-name": "Path 11889",
    d: "M678.61,1225.072c47.33,0,85.7,5.442,85.7,12.187,0,6.724-38.371,12.166-85.7,12.166s-85.712-5.442-85.712-12.166c0-6.745,38.371-12.187,85.712-12.187",
    transform: "translate(-23299.832 -23388.984)",
    fill: "#d6daf9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11890",
    "data-name": "Path 11890",
    d: "M848.817,0c14.173,41.506,55.72,97.681,53.03,136.441-1.965,28.243-22.015,48-53.03,48.458-31.016-.455-51.07-20.215-53.036-48.458C793.086,97.684,834.633,41.509,848.817,0",
    transform: "translate(-23470.039 -22360.588)",
    fill: "#becdf1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11891",
    "data-name": "Path 11891",
    d: "M939.995,691.6a1.782,1.782,0,0,1,2.048-2.917,41.982,41.982,0,0,0,12.409,5.959,54.329,54.329,0,0,0,14.9,2.214c9.817-.144,18.518-2.565,25.543-6.993a38.341,38.341,0,0,0,15.342-18.684,1.779,1.779,0,1,1,3.311,1.3,41.644,41.644,0,0,1-16.76,20.38c-7.572,4.78-16.915,7.387-27.415,7.552h-.052a58.893,58.893,0,0,1-15.891-2.338,46.262,46.262,0,0,1-13.433-6.476m76.675-31.947a1.78,1.78,0,1,1-3.538-.393l.124-1.2.083-1.221a50.669,50.669,0,0,0-.29-9.58,77.006,77.006,0,0,0-1.821-9.834c-.6-2.462-1.314-4.934-2.08-7.366s-1.583-4.769-2.41-7a1.786,1.786,0,0,1,3.352-1.231c.848,2.317,1.686,4.717,2.462,7.169s1.5,4.976,2.142,7.573a85.11,85.11,0,0,1,1.9,10.278,53.924,53.924,0,0,1,.3,10.222l-.1,1.3Z",
    transform: "translate(-23590.572 -22881.604)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11892",
    "data-name": "Path 11892",
    d: "M1558.563,1051.865c-.062.31-1.076-.269-1.863-.932s-2.9-2.524-2.606-2.979c.269-.476,2.834.186,3.517.869a22.251,22.251,0,0,1,.952,3.042m2.152,2.462c-.062-.31.62-.434,1.189-1.055s-2.12-4.738-2.493-5.607-2.617-2.607-3.921-3.1-5.235.807-7.107.807h-1.614s-3.114,2.628-2.855,3.517,3.1,3.911,3.6,4.945,5.183,4.283,7.428,5.69c2.235,1.427,2.586-.186,2.586-.186a12.079,12.079,0,0,0,2.959,1.055c1.924.476,1.417-.952,1.417-.952.435-.124,3.549,1.49,3.611.311s-4.738-5.111-4.8-5.421",
    transform: "translate(-24098.16 -23237.357)",
    fill: "#ffb27d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11893",
    "data-name": "Path 11893",
    d: "M582.888,1066.38c.688-.683,3.238-1.345,3.523-.89.279.476-1.841,2.338-2.617,3s-1.805,1.242-1.867.931a22.1,22.1,0,0,1,.962-3.041m-7.909,10.925c.062,1.179,3.176-.435,3.616-.311,0,0-.76,1.3,1.195.952a12.487,12.487,0,0,0,3.176-1.056s-.166,1.593,2.214.435c2.385-1.179,7.314-4.9,7.806-5.938s3.336-4.056,3.595-4.945-2.855-3.518-2.855-3.518h-1.619c-1.867,0-5.794-1.324-7.1-.828-1.309.518-3.554,2.255-3.926,3.124s-3.047,4.986-2.488,5.607,1.241.745,1.179,1.055-4.852,4.242-4.8,5.421",
    transform: "translate(-23284.789 -23252.078)",
    fill: "#f9af79",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11894",
    "data-name": "Path 11894",
    d: "M965.032,1056.172c-.32,2.235-13.728,11.628-16.366,13.511a28.824,28.824,0,0,1-7.169,3.393c-7.283,1.9-52.948,15.539-52.948,15.539a5.961,5.961,0,0,0-.45-1.387c-1.707.683-3.461,1.118-4.578,1.469-1.7.538-15.2.952-17.96,1.49-2.762.517-8.292,1.386-10.521-.745s1.381-6.7,4.464-7.862c3.083-1.179,14.344-1.49,16.367-1.7,2.017-.227,4.676-.972,5.949-.538.4.124,2.183-.393,4.433-1.159-.052-.828-.067-1.365-.067-1.365l11.985-3.455-2.214-21.229s5.214-19.656,26.06-4.655c0,0,4.645,1.366,6.238,1.779a1.437,1.437,0,0,0,.538.021c3.186-.228,16.842-4.366,21.787-4.366,5.317,0,7.014-.331,8.928.642,1.914.952,5.845,8.38,5.524,10.614",
    transform: "translate(-23519.309 -23235.168)",
    fill: "#699dee",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11895",
    "data-name": "Path 11895",
    d: "M835.543,1092.151c-2.234,2.131-7.759,1.262-10.521.745-2.772-.538-16.263-.952-17.96-1.49s-4.883-1.283-7.118-2.772a10.64,10.64,0,0,0-1.2-.518l-3.373,2.442-46.927-14.939a16.82,16.82,0,0,1-6.528-3.228c-2.447-2.131-16.046-11.276-16.366-13.511s3.61-9.663,5.524-10.614c1.914-.973,3.611-.642,8.928-.642s20.722,4.78,22.315,4.345a23.069,23.069,0,0,0,3.647-1.717c1.707-.931,3.3-1.883,3.3-1.883,22.817-10.2,25.362,6.476,25.362,6.476l-1.345,20.588s1.893.931,4.365,2.111l11.318,3.207-1.49,1.055a2.975,2.975,0,0,0,1.283.248c1.282-.435,3.931.31,5.959.538,2.007.207,13.283.518,16.356,1.7,3.094,1.159,6.693,5.731,4.469,7.862",
    transform: "translate(-23411.174 -23237.875)",
    fill: "#699dee",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11896",
    "data-name": "Path 11896",
    d: "M885.958,1128.029s-14.846-8.9-21.327-10.3c-6.125-1.324-8.359-3.621-8.359-3.621s9.74,0,16.222,4.614c4.407,3.124,13.465,9.311,13.465,9.311",
    transform: "translate(-23520.924 -23295.832)",
    fill: "#4a75cb",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11897",
    "data-name": "Path 11897",
    d: "M1123.317,1134.216s25.822-13.553,36.354-16.491c6.042-1.676,8.359-3.621,8.359-3.621s-15.953,1.572-25.657,7.407c-4.635,2.794-19.056,12.7-19.056,12.7",
    transform: "translate(-23745.098 -23295.832)",
    fill: "#4a75cb",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11898",
    "data-name": "Path 11898",
    d: "M1218.371,1284.265c-2.234,2.131-7.759,1.262-10.521.745-2.772-.538-16.263-.952-17.96-1.49s-4.883-1.283-7.118-2.772a10.7,10.7,0,0,0-1.2-.518l8.731-6.31a2.972,2.972,0,0,0,1.283.248c1.283-.434,3.931.31,5.959.538,2.007.207,13.283.518,16.356,1.7,3.094,1.159,6.694,5.731,4.469,7.863",
    transform: "translate(-23794.002 -23429.99)",
    fill: "#f9af79",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11899",
    "data-name": "Path 11899",
    d: "M888.1,1277.291c-1.707.683-3.461,1.118-4.578,1.469-1.7.538-15.2.952-17.96,1.49-2.762.517-8.292,1.386-10.521-.745s1.381-6.7,4.464-7.863c3.083-1.179,14.344-1.49,16.367-1.7,2.017-.227,4.676-.972,5.949-.538.4.125,2.183-.393,4.433-1.159.072,1.345,1.847,9.042,1.847,9.042",
    transform: "translate(-23519.309 -23425.229)",
    fill: "#f9af79",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11901",
    "data-name": "Path 11901",
    d: "M1123.317,1297.646l11.877-3.621-8.235,4.78Z",
    transform: "translate(-23745.098 -23446.867)",
    fill: "#4a75cb",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11902",
    "data-name": "Path 11902",
    d: "M958.32,1077.374c1.578.1,12.213,6.269,14.732,7.738-3.833-2.007-18.379-6.021-18.379-6.021a23.046,23.046,0,0,0,3.647-1.717",
    transform: "translate(-23603.529 -23264.998)",
    fill: "#4a75cb",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11903",
    "data-name": "Path 11903",
    d: "M1069.693,1125.884c-.026-.021-.212-.124-.538-.311a3.324,3.324,0,0,1,.538.311",
    transform: "translate(-23699.631 -23305.459)",
    fill: "#494848",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11904",
    "data-name": "Path 11904",
    d: "M1204.73,1078.786s-18.312,4.448-21.674,6.311c.155-.1,9.9-7.159,14.9-8.111,0,0,4.645,1.366,6.238,1.779a1.432,1.432,0,0,0,.538.021",
    transform: "translate(-23795.246 -23264.672)",
    fill: "#4a75cb",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11905",
    "data-name": "Path 11905",
    d: "M781.057,772.584s-3.724-9.27-3.8-11.463a72.81,72.81,0,0,1,1.376-11.98c.7-2.772,2.525-7.924,2.525-7.924s9.776,10.7,11.256,12.042,3.828,5.814,5.917,7.925c2.09,2.131,29.153,13.531,29.153,13.531.786.58,3.393-4.242,3.393-4.242a89.323,89.323,0,0,1-11.607-7.572c-4.325-3.621-15.663-11.07-15.942-11.339-.28-.29-10.625-12.476-13.253-19.428-2.607-6.932-8.917-10.118-11.9-11.111s-12.466-4.039-12.466-4.039h-12.4s-15.875,5.3-18.989,6.874c-3.119,1.552-8.359,12.683-9.424,13.945-1.061,1.283-7.635,12.311-13.744,15.518-3.285,1.738-19.4,19.139-20.531,19.987s2.586,4.035,2.586,4.035,20.137-12.332,23.469-14.09a22.026,22.026,0,0,0,7.014-6.559c.926-1.428,11.69-13.346,11.69-13.346s4.04,8.856,5.173,13.449a19.291,19.291,0,0,1,.569,8.152c-.243,2.4-.383,3.042-2.9,8.9,0,0,27.586,3.7,42.825-1.263",
    transform: "translate(-23381.691 -22962.463)",
    fill: "#ffb27d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11906",
    "data-name": "Path 11906",
    d: "M951.9,738.464l-9.125,7.242c-2.245-2.421-4.127-4.49-4.127-4.49s-1.821,5.152-2.524,7.924a72.787,72.787,0,0,0-1.376,11.98c.072,2.193,3.8,11.462,3.8,11.462-15.239,4.966-42.825,1.263-42.825,1.263,2.514-5.856,2.654-6.5,2.9-8.9a19.29,19.29,0,0,0-.569-8.152c-1.133-4.594-5.173-13.449-5.173-13.449s-2.768,3.062-5.623,6.269l-9.233-7.449c1.748-2.441,3.373-5.09,3.792-5.586,1.06-1.283,6.885-11.173,10-12.725,3.114-1.572,18.989-6.875,18.989-6.875h12.4s9.487,3.046,12.467,4.04a22.056,22.056,0,0,1,12.249,9.994c1.252,2.172,2.421,5.048,3.983,7.449",
    transform: "translate(-23539.18 -22962.463)",
    fill: "#040227",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11907",
    "data-name": "Path 11907",
    d: "M1069.375,504.232s9.7,1.531,8.224,16.7-10.035,13.925-10.6,13.915-8.592.279-9.218-18.25c0,0-.274-13.7,11.6-12.363",
    transform: "translate(-23690.078 -22783.791)",
    fill: "#ffb27d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11908",
    "data-name": "Path 11908",
    d: "M1089.921,658.94s-.3,6.58.311,7.935-8.126,5.116-13.376.289c0,0,1.422-6.569,1.066-8.969s12,.745,12,.745",
    transform: "translate(-23706.096 -22912.355)",
    fill: "#f9af79",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11909",
    "data-name": "Path 11909",
    d: "M1179.223,579.413s1.066-1.138,1.458.01-1.448,6.269-1.51,6.507c0,0-.207.445-.455.207s.507-6.724.507-6.724",
    transform: "translate(-23791.559 -22846.555)",
    fill: "#ffb27d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11910",
    "data-name": "Path 11910",
    d: "M1051.463,578.131s-1.04-1.148-1.454-.01,1.314,6.29,1.392,6.538c0,0,.186.445.445.207s-.383-6.735-.383-6.735",
    transform: "translate(-23683.506 -22845.471)",
    fill: "#ffb27d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11911",
    "data-name": "Path 11911",
    d: "M1071.874,507.612l-1.387,1.852a38.242,38.242,0,0,0-.186-4.707c-.217-.631-.569-2.586-.755-3.042s-8.318-2.742-15.508.662c0,0,.311,2.928-.377,3.186s-.346,4.769-.346,4.769l-1.143-1.293s-1.749-11.67-1.319-12.89,1.81-8.525,16.563-4.179c0,0,4.593-.983,5.525,2.193.91,3.176-1.066,13.449-1.066,13.449",
    transform: "translate(-23684.209 -22772.428)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11912",
    "data-name": "Path 11912",
    d: "M1088.11,713.027l-8.949,11.375-6.658-11.375a11.805,11.805,0,0,1,2.5-.734c8.194-1.811,13.108.734,13.108.734",
    transform: "translate(-23702.443 -22957.98)",
    fill: "#f9af79",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11913",
    "data-name": "Path 11913",
    d: "M1083.395,677.1a7.8,7.8,0,0,0,5.644,2.8c2.266,0,4.055-.8,6.321-3a6.875,6.875,0,0,1-6.311,4.738s-3.947.238-5.654-4.542",
    transform: "translate(-23711.586 -22928.814)",
    fill: "#ed985f",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeditation);
export default __webpack_public_path__ + "static/media/meditation.9484d386f74fd7fd704ee0bf3fc14e02.svg";
export { ForwardRef as ReactComponent };